<template>
  <li class="article--excerpt-wrapper">
    <article class="article-list-item">
      <a
        class="article--excerpt-image"
        :class="{ 'is-event': meta === 'Event' }"
        :href="url"
        :style="`background-image: url(${sizedImageSrc});`"
      >
        <img :src="sizedImageSrc" :alt="title" :srcset="sizedImageSrc" />
      </a>

      <div class="article--excerpt-content">
        <div class="article--excerpt-meta">
          <span class="article--excerpt-meta-item"> {{ meta }}: </span>
        </div>

        <h2 class="article--excerpt-title">
          <a :href="url">
            {{ title }}
          </a>
        </h2>

        <span
          v-if="canShowPublishedDate"
          class="article--excerpt-meta-item published-date"
        >
          {{ publishedDate }}
        </span>

        <div class="article--excerpt-text rte">
          <span v-html="excerpt" />
        </div>

        <a
          class="article--excerpt-readmore"
          :href="url"
          :aria-label="readMoreLabel"
        >
          {{ readMoreLabel }}
        </a>
      </div>
    </article>
  </li>
</template>

<script>
import * as ShopifyImage from '@shopify/theme-images';

export default {
  props: {
    title: {
      type: String
    },
    imageSrc: {
      type: String
    },
    url: {
      type: String
    },
    meta: {
      type: String
    },
    id: {
      type: Number
    },
    readMoreLabel: {
      type: String
    },
    excerpt: {
      type: String
    },
    imagePlaceholder: {
      type: String
    },
    publishedDate: {
      type: String
    },
    canShowPublishedDate: {
      type: Boolean
    }
  },
  computed: {
    sizedImageSrc() {
      if (this.imageSrc) {
        return ShopifyImage.getSizedImageUrl(
          this.imageSrc,
          this.meta === 'Event' ? '1200x' : '500x'
        );
      } else {
        return this.imagePlaceholder;
      }
    }
  }
};
</script>
